import { baseRoute } from '../../../../../constants/routes';

export const TEXT_POLL_ANSWERS_HATCH_ROUTE = baseRoute + '/text-poll-answers';
